import React from 'react';
import { Alert } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';

export interface LomavisIssueListAlertItem1 {
  id?: string;
  label?: React.ReactNode;
  message: React.ReactNode;
}

export interface LomavisIssueListAlert1Props {
  issues: LomavisIssueListAlertItem1[];
  title?: React.ReactNode;
  variant?: string;
  className?: string;
}

/**
 * Atoms: LomavisIssueListAlert1
 *
 * Alert for summarizing a list of issues near the action that needs attention.
 */
export const LomavisIssueListAlert1: React.FC<LomavisIssueListAlert1Props> = ({
  issues,
  title,
  variant = 'danger',
  className = ''
}) => {
  const { t } = useTranslate();
  const resolvedTitle =
    title ??
    t(
      'adManager.validation.completeItems',
      'Complete these items before publishing:'
    );

  if (issues.length === 0) return null;

  return (
    <Alert
      variant={variant}
      className={`m-0 w-100 py-3 px-4 fs-6 ${className}`.trim()}
      role="alert"
    >
      {resolvedTitle && <div className="fw-bold">{resolvedTitle}</div>}
      <ul className="mb-0 mt-2 ps-4">
        {issues.map((issue, index) => {
          const key =
            issue.id ||
            `${[
              issue.label,
              issue.message
            ]
              .filter(Boolean)
              .map(String)
              .join(':')}:${index}`;

          return (
            <li key={key}>
              {issue.label && <strong>{issue.label}: </strong>}
              {issue.message}
            </li>
          );
        })}
      </ul>
    </Alert>
  );
};
